<script>
	// export let klass = ''
	export let size='h-5 w-5'
</script>

<!-- <svg
    on:click
    class={klass}
    style="enable-background:new 0 0 15 15;"
    version="1.1"
    viewBox="0 0 15 15"
    xml:space="preserve"
    xmlns="http://www.w3.org/2000/svg"
    xmlns:xlink="http://www.w3.org/1999/xlink">
    <path d="M7.5,0C3.364,0,0,3.364,0,7.5S3.364,15,7.5,15S15,11.636,15,7.5S11.636,0,7.5,0z M7.5,14C3.916,14,1,11.084,1,7.5  S3.916,1,7.5,1S14,3.916,14,7.5S11.084,14,7.5,14z"/>
    <polygon points="6.505,8.853 3.861,6.209 3.154,6.916 6.51,10.272 11.856,4.851 11.144,4.149 "/>
</svg> -->

<!-- Heroicon name: solid/check -->
<svg
	class="flex-shrink-0 {size} text-green-500"
	xmlns="http://www.w3.org/2000/svg"
	viewBox="0 0 20 20"
	fill="currentColor"
	aria-hidden="true"
>
	<path
		fill-rule="evenodd"
		d="M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z"
		clip-rule="evenodd"
	/>
</svg>
